import React from 'react';
import AssetList from './asset_list'
import { Message } from "../Message";
import { PageTitle } from "../PageTitle";
import i18next from "i18next";

class Assets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localErrorMessage: null
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
          <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    if (this.props.location.state) {
      return (
          <Message messages={this.props.location} />
      );
    }
    
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  handleHistoryUpdate(params) {
    this.props.history.push(params);
  }

  refresh() {
    this.setState({refresh: true})
  }

  render() {
    return (
        <div className="animated fadeIn">
          <div className="row">
            <PageTitle title={ i18next.t('pages.asset-configuration.header') } refreshFunction={this.refresh.bind(this)} />
          </div>
          { this.renderMessages() }
          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="card-block">

                    <AssetList
                      refresh = {this.state.refresh}
                      finishedRefresh = {() => {this.setState({refresh: false})}}
                      currLocation = {this.props.history.location}
                      localErrorHandler={this.handleLocalError.bind(this)}
                      pushHistory={this.handleHistoryUpdate.bind(this)}
                    />

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Assets;
